<template>
  <nav class="flex flex-1 flex-col px-5 py-6 overflow-hidden" style="--nav-theme-color: var(--color-infertility-clinic-admin);">
    <div class="flex-1 space-y-3 overflow-y-auto min-h-0">
      <!-- Dashboard -->
      <Link
        :href="$routes.admin_infertility_treatment_clinic()"
        :class="[
          'group nav-link text-xs font-bold uppercase tracking-wider',
          isExactUrl('admin/infertility-treatment-clinic') ? 'nav-link-active' : 'nav-link-inactive',
        ]"
      >
        <span>Dashboard</span>
      </Link>

      <!-- Pages Section (dynamic) -->
      <AdminPagesSidebarSection site_context="infertility_treatment_clinic" />

      <!-- BLOCKS -->
      <div class="p-2 bg-white/10 rounded-md">
        <h1 class="text-lg font-bold text-white/90 mb-[-5px] px-3">BLOKI</h1>

        <div class="space-y-1 mb-2">
          <div
            class="flex items-center px-3 py-2 text-xs font-bold uppercase tracking-wider text-white/90 select-none"
          >
            <span>Ogólne</span>
          </div>
          <div class="ml-4 space-y-1">
            <Link
              :href="$routes.admin_infertility_treatment_clinic_header_blocks()"
              :class="[
                'group nav-link',
                isBlockKindActive('header') ? 'nav-link-active' : 'nav-link-inactive',
              ]"
            >
              <span>Nagłówki</span>
            </Link>
            <Link
              :href="$routes.admin_infertility_treatment_clinic_features_blocks()"
              :class="[
                'group nav-link',
                isBlockKindActive('features') ? 'nav-link-active' : 'nav-link-inactive',
              ]"
            >
              <span>Wyróżnienia</span>
            </Link>
            <Link
              :href="$routes.admin_infertility_treatment_clinic_cta_blocks()"
              :class="[
                'group nav-link',
                isBlockKindActive('cta') ? 'nav-link-active' : 'nav-link-inactive',
              ]"
            >
              <span>CTA</span>
            </Link>
            <Link
              :href="$routes.admin_infertility_treatment_clinic_footer_blocks()"
              :class="[
                'group nav-link',
                isBlockKindActive('footer') ? 'nav-link-active' : 'nav-link-inactive',
              ]"
            >
              <span>Stopki</span>
            </Link>
            <Link
              :href="$routes.admin_infertility_treatment_clinic_content_blocks()"
              :class="[
                'group nav-link',
                isBlockKindActive('content') ? 'nav-link-active' : 'nav-link-inactive',
              ]"
            >
              <span>Treść</span>
            </Link>
          </div>
        </div>

        <div class="space-y-1">
          <div
            class="flex items-center px-3 py-2 text-xs font-bold uppercase tracking-wider text-white/90 select-none"
          >
            <span>Tylko API</span>
          </div>
          <div class="ml-4 space-y-1">
            <Link
              :href="$routes.admin_infertility_treatment_clinic_carousel_blocks()"
              :class="[
                'group nav-link',
                isBlockKindActive('carousel') ? 'nav-link-active' : 'nav-link-inactive',
              ]"
            >
              <span>Karuzele</span>
            </Link>
          </div>
        </div>
      </div>
    </div></nav>

  <!-- Back Link -->
  <div class="mt-auto border-t border-white/10 bg-black/20 px-5 py-4">
    <Link
      :href="$routes.admin_index()"
      class="group flex items-center px-3 py-2 text-sm font-medium text-white/75 hover:text-white hover:bg-white/10 rounded-md transition-all duration-200"
    >
      <icon name="cheveron-left" class="mr-2 h-3.5 w-3.5 fill-white/75 group-hover:fill-white transition-all group-hover:-translate-x-0.5" />
      <span>Powrót do panelu administracyjnego</span>
    </Link>
  </div>
</template>

<script>
import { Link } from '@inertiajs/vue3';
import Icon from '@/Shared/Icon.vue';
import AdminPagesSidebarSection from '@/Components/AdminPagesSidebarSection.vue';

// Maps a Template#category (`kind`) to its `/admin/.../blocks/<path>` segment.
// Mirrors BLOCK_CATEGORY_PATHS in config/routes.rb.
const BLOCK_KIND_PATHS = {
  header: 'headers',
  carousel: 'carousels',
  features: 'features',
  cta: 'cta',
  footer: 'footers',
  content: 'content',
};

export default {
  components: {
    Link,
    Icon,
    AdminPagesSidebarSection,
  },
  methods: {
    isExactUrl(url) {
      let currentUrl = this.$page.url.slice(1);
      currentUrl = currentUrl.replace(/\/$/, '');
      url = url.replace(/\/$/, '');
      return currentUrl === url;
    },
    isUrl(...urls) {
      let currentUrl = this.$page.url.slice(1);
      return urls.filter((url) => currentUrl.startsWith(url)).length > 0;
    },
    isBlockKindActive(kind) {
      const currentUrl = this.$page.url.slice(1).replace(/\/$/, '');
      const path = BLOCK_KIND_PATHS[kind];
      return !!path && currentUrl === `admin/infertility-treatment-clinic/blocks/${path}`;
    },
  },
};
</script>
